module.exports = __webpack_public_path__ + "static/media/icn_video_default_thumbnail.28f56d4a.png";